export default "__VITE_ASSET__lI7zyov2__"